import { MODULE_IDS } from '../constants';

/** Firestore notification `type` values. */
export const NOTIFICATION_TYPES = {
  QNA_ANSWER: 'qna.answer',
  QNA_NEW_QUESTION: 'qna.new_question',
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.QNA_ANSWER]: 'Odgovor na vprašanje',
  [NOTIFICATION_TYPES.QNA_NEW_QUESTION]: 'Novo vprašanje',
};

export const NOTIFICATION_MODULE_IDS = {
  [NOTIFICATION_TYPES.QNA_ANSWER]: MODULE_IDS.QNA,
  [NOTIFICATION_TYPES.QNA_NEW_QUESTION]: MODULE_IDS.QNA,
};

export const NOTIFICATIONS_PAGE_SIZE = 30;
